import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import { CURRENCY, FORMAT_NUMBER } from '../../libs/utils/Const';
import TableHeader from './TableHeader'
import TableRow from './TableRow'
import TableBlankSpace from './TableBlankSpace'
import TableFooter from './TableFooter'
import { Table } from 'react-bootstrap';
import { isSalesDocument, isPurchaseDocument } from '../../libs/utils/GlobalFunc';

const styles = StyleSheet.create({
  tableContainer: {
    width: '97%',
    margin: '15 auto',
    paddingBottom: 20,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#e2e2e2',
    display: 'flex',
    flexDirection: 'row',
  },

  header1: {
    display: 'flex',
    flexDirection: 'row',
  },

  headers: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
    flexWrap: 'wrap',
    height: 24
  },
  text: {
    display: 'flex',
    fontSize: '8px',
    alignSelf: 'center',
    fontWeight: '300'
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  cell: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    fontSize: '8px',
    textAlign: 'center',
    paddingTop: '2px',
    paddingLeft: '2px'

  },
  itemcode: {
    minWidth: '15%',
    maxWidth: '15%',
  },
  ean: {
    minWidth: '18%',
    maxWidth: '18%',
  },
  qty: {
    minWidth: '10%',
    maxWidth: '10%',
  },
  unit: {
    minWidth: '8%',
    maxWidth: '8%'
  },
  description: {
    minWidth: '15%',
    maxWidth: '15%',
  },
  price: {
    minWidth: '7%',
    maxWidth: '7%',
  },
  dicount: {
    minWidth: '7%',
    maxWidth: '7%'
  },
  igv: {
    minWidth: '5%',
    maxWidth: '5%',
  },
  isc: {
    minWidth: '5%',
    maxWidth: '5%',
  },
  total: {
    minWidth: '15%',
    maxWidth: '15%',
  },

  // Estilos para nota de crédito y facturas
  text1: {
    display: 'flex',
    fontSize: '7px',
    alignSelf: 'center',
    fontWeight: '300'
  },

  cnNumber: {
    minWidth: '5%',
    maxWidth: '5%',
    fontSize: '7px'
  },
  cnItem: {
    minWidth: '12%',
    maxWidth: '12%',
    fontSize: '7px'
  },
  cnDescription: {
    minWidth: '35%',
    maxWidth: '35%',
    fontSize: '7px'
  },
  cnUnit: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  cnQty: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  cnPrice: {
    minWidth: '12%',
    maxWidth: '12%',
    fontSize: '7px'
  },
  cnTotal: {
    minWidth: '16%',
    maxWidth: '16%',
    fontSize: '7px'
  },

  invCodigo: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invDescripcion: {
    minWidth: '26%',
    maxWidth: '26%',
    fontSize: '7px'
  },
  invUm: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invCantidad: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invPrecioUnitario: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invDescuento: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invImpuesto: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invPrecioTotal: {
    minWidth: '10%',
    maxWidth: '10%',
    fontSize: '7px'
  },


  tableContainer1: {
    width: '100%',
    margin: '15 auto',
    paddingBottom: 20,
    display: 'flex',
    flexDirection: 'column',
  },

  invCodigoOC1: {
    minWidth: '15%',
    maxWidth: '15%',
    fontSize: '7px'
  },

  invDescripcionOC1: {
    minWidth: '25%',
    maxWidth: '25%',
    fontSize: '7px'
  },

  invCantidad1: {
    minWidth: '14%',
    maxWidth: '14%',
    fontSize: '7px'
  },

  umOC1: {
    minWidth: '5%',
    maxWidth: '5%',
    fontSize: '7px',
  },

  invPrecioUnitarioOC1: {
    minWidth: '14%',
    maxWidth: '14%',
    fontSize: '7px',
  },

  invPrecioTotalOC1: {
    minWidth: '27%',
    maxWidth: '27%',
    fontSize: '7px'
  },

  // Estilos antiguos (mantener para compatibilidad)
  codigo: {
    minWidth: '12%',
    maxWidth: '12%',
    fontSize: '8px',
  },
  descripcion: {
    minWidth: '46%',
    fontSize: '8px',
    maxWidth: '46%',
  },
  um: {
    minWidth: '6%',
    fontSize: '8px',
    maxWidth: '6%',
  },
  cantidad: {
    minWidth: '7%',
    fontSize: '8px',
    maxWidth: '7%',
  },
  pvu: {
    minWidth: '10%',
    fontSize: '8px',
    maxWidth: '10%',
  },
  vvu: {
    minWidth: '9%',
    fontSize: '8px',
    maxWidth: '9%',
  },
  valorTotal: {
    minWidth: '10%',
    fontSize: '8px',
    maxWidth: '10%',
  },

  // TABLA DE DETALLE DE ARTÍCULOS
  articleTableContainer: {
    marginTop: 10,
    marginBottom: 15,
  },
  articleHeader: {
    backgroundColor: '#1e5a7d',
    color: 'white',
    padding: 5,
    fontSize: 9,
    fontWeight: 'bold',
  },
  articleTableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    backgroundColor: '#f0f0f0',
    fontSize: 7,
    fontWeight: 'bold',
  },
  articleRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    minHeight: 20,
  },
  articleCol1: {
    width: '15%',
    padding: 3,
    fontSize: 7,
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol2: {
    width: '14%',
    padding: 3,
    fontSize: 7,
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol3: {
    width: '14%',
    fontSize: 7,
    textAlign: 'center',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol4: {
    width: '14%',
    fontSize: 7,
    textAlign: 'center',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol5: {
    width: '15%',
    fontSize: 7,
    textAlign: 'center',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol6: {
    width: '14%',
    fontSize: 7,
    textAlign: 'center',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#ccc'
  },
  articleCol7: {
    width: '14%',
    fontSize: 7,
    textAlign: 'center',
    padding: 3
  },

  // TABLA DE CONTROL DE MOVIMIENTO
  cylinderTableContainer: {
    marginTop: 10,
  },

  cylinderContainer: {
    borderWidth: 1,
    borderColor: '#000',
  },

  cylinderHeader: {
    backgroundColor: '#1e5a7d',
    color: 'white',
    padding: 5,
    fontSize: 9,
    fontWeight: 'bold',
  },
  cylinderInfoLines: {
    width: '100%',
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  infoLineText: {
    fontSize: 7.5,
    flex: 1,
    marginHorizontal: 5,
  },
  cylinderMainHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    fontSize: 7,
    minHeight: 20,
  },
  cylinderDetailColHeader: {
    width: '20%',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#000',
    fontSize: 9,
    justifyContent: 'center',
  },
  cylinderIngresoColHeader: {
    width: '26.66%',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#000',
    justifyContent: 'center',
  },
  cylinderSalidaColHeader: {
    width: '26.66%',
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: '#000',
    justifyContent: 'center',
  },
  cylinderQuedanColHeader: {
    width: '26.66%',
    padding: 3,
    justifyContent: 'center',
  },
  cylinderSubColumns: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    fontSize: 6,
    minHeight: 25,
  },
  subCol: {
    width: '13.33%',
    padding: 2,
    borderRightWidth: 1,
    borderRightColor: '#000',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subColText: {
    fontSize: 6,
    textAlign: 'center',
  },
  emptySubCol: {
    width: '20%',
    padding: 2,
    borderRightWidth: 1,
    borderRightColor: '#000'
  },
  quedanSubColEmpty: {
    width: '26.66%',
    padding: 2,
  },
  cylinderDataRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    minHeight: 20,
  },
  detailCell: {
    width: '20%',
    borderRightWidth: 1,
    borderColor: '#000',
    padding: 5,
    justifyContent: 'center',
  },
  dataCell: {
    width: '13.33%',
    borderRightWidth: 1,
    borderColor: '#000',
    padding: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  quedanCell: {
    width: '20%',
    padding: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cylinderText: {
    fontSize: 7,
  },
  textBold: {
    fontWeight: 'bold',
    fontSize: 7,
  },
  textCenter: {
    textAlign: 'center',
  },
  conveniosTableContainer: {
    marginTop: 5,
    marginBottom: 5,
    borderWidth: 1,
    borderColor: '#000',
    width: '50%',
  },
  conveniosTableHeader: {
    flexDirection: 'row',
    backgroundColor: '#e2e2e2',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
  },
  conveniosTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    minHeight: 15,
  },
  conveniosCell: {
    padding: 2,
    justifyContent: 'center',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  conveniosHeaderText: {
    fontSize: 6.5,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  convenioCellText: {
    fontSize: 6,
    textAlign: 'center',
  },
  convenioDescripcionCol: {
    width: '40%',
    borderRightWidth: 0,
  },
  // Y ajustar los otros anchos:
  convenioCantidadCol: {
    width: '15%',
  },
  convenioUnidadCol: {
    width: '15%',
  },
  convenioModeloCol: {
    width: '30%',
    borderRightWidth: 1,
    borderRightColor: '#ccc',
  },
  headerOC: {
    display: 'flex',
    flexDirection: 'row',
  },
  idNum: {
    minWidth: '6%',
    maxWidth: '6%',
    fontSize: '7px'
  },
  invCodigoOC: {
    minWidth: '15%',
    maxWidth: '10%',
    fontSize: '7px'
  },
  invDescripcionOC: {
    minWidth: '41%',
    maxWidth: '41%',
    fontSize: '7px'
  },
  invPrecioTotalOC: {
    minWidth: '18%',
    maxWidth: '18%',
    fontSize: '7px'
  },
});

const ItemsTable = ({ items, header, view, format }) => {
  // let blankRows = Array((items.length + 2) - items.length).fill(0)

  if (view === 'creditNote' && header.U_BPP_MDTD === 'DV') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={styles.header} fixed>
            <View style={[styles.headers, styles.cnNumber]}>
              <Text style={styles.text1}>N°</Text>
            </View>
            <View style={[styles.headers, styles.cnItem]}>
              <Text style={styles.text1}>ITEM</Text>
            </View>
            <View style={[styles.headers, styles.cnDescription]}>
              <Text style={styles.text1}>DESCRIPCION</Text>
            </View>
            <View style={[styles.headers, styles.cnUnit]}>
              <Text style={styles.text1}>UNIDAD MED</Text>
            </View>
            <View style={[styles.headers, styles.cnQty]}>
              <Text style={styles.text1}>CANTIDAD</Text>
            </View>
            <View style={[styles.headers, styles.cnPrice]}>
              <Text style={styles.text1}>PU</Text>
            </View>
            <View style={[styles.headers, styles.cnTotal]}>
              <Text style={styles.text1}>TOTAL</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={[styles.cell, styles.cnNumber]}>
                <Text>{index + 1}</Text>
              </View>
              <View style={[styles.cell, styles.cnItem]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.cnDescription]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.cnUnit]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cnQty]}>
                <Text>{Number.parseFloat(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.cnPrice]}>
                <Text>{Number.parseFloat(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.cnTotal]}>
                <Text>{Number.parseFloat(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.cnNumber, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnItem]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnDescription]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnUnit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnQty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnPrice]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnTotal]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    );
  }

  if (view === 'invoice' && header.U_BPP_MDTD === 'CU') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={styles.header} fixed>
            <View style={[styles.headers, styles.cnNumber]}>
              <Text style={styles.text1}>N°</Text>
            </View>
            <View style={[styles.headers, styles.cnItem]}>
              <Text style={styles.text1}>ITEM</Text>
            </View>
            <View style={[styles.headers, styles.cnDescription]}>
              <Text style={styles.text1}>DESCRIPCION</Text>
            </View>
            <View style={[styles.headers, styles.cnUnit]}>
              <Text style={styles.text1}>UNIDAD MED</Text>
            </View>
            <View style={[styles.headers, styles.cnQty]}>
              <Text style={styles.text1}>CANTIDAD</Text>
            </View>
            <View style={[styles.headers, styles.cnPrice]}>
              <Text style={styles.text1}>PU</Text>
            </View>
            <View style={[styles.headers, styles.cnTotal]}>
              <Text style={styles.text1}>TOTAL</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={[styles.cell, styles.cnNumber]}>
                <Text>{index + 1}</Text>
              </View>
              <View style={[styles.cell, styles.cnItem]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.cnDescription]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.cnUnit]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cnQty]}>
                <Text>{Number.parseFloat(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.cnPrice]}>
                <Text>{Number.parseFloat(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.cnTotal]}>
                <Text>{Number.parseFloat(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.cnNumber, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnItem]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnDescription]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnUnit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnQty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnPrice]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.cnTotal]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    );
  }

  if (view === 'orderSales' && header.U_RS_TIPOV === 'ENVASA') {
    return (
      <>
        <View>
          <View style={styles.articleTableContainer}>
            <View style={styles.articleHeader}>
              <Text>DETALLE DE ARTÍCULOS</Text>
            </View>

            <View style={styles.cylinderContainer}>
              <View style={styles.articleTableHeader}>
                <View style={styles.articleCol1}>
                  <Text>Descripción de artículos</Text>
                </View>
                <View style={styles.articleCol2}>
                  <Text>Cantidad</Text>
                </View>
                <View style={styles.articleCol3}>
                  <Text>Entrega cilindros</Text>
                </View>
                <View style={styles.articleCol4}>
                  <Text>Tipo de convenio</Text>
                </View>
                <View style={styles.articleCol5}>
                  <Text>Cant. cilindros que entrega</Text>
                </View>
                <View style={styles.articleCol6}>
                  <Text>Cant. cilindros físicos (en buenas condiciones)</Text>
                </View>
                <View style={styles.articleCol7}>
                  <Text>Cantidad atendida</Text>
                </View>
              </View>
              {items.map((article, index) => (
                <View key={index} style={styles.articleRow}>
                  <View style={styles.articleCol1}>
                    <Text>{article.Dscription || ''}</Text>
                  </View>
                  <View style={styles.articleCol2}>
                    <Text>{article.Quantity || ''}</Text>
                  </View>
                  <View style={styles.articleCol3}>
                    <Text>{article.U_RML_ENTCLNDRO || ''}</Text>
                  </View>
                  <View style={styles.articleCol4}>
                    <Text>{article.U_RML_TIPO_CU || ''}</Text>
                  </View>
                  <View style={styles.articleCol5}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.articleCol6}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.articleCol7}>
                    <Text>{''}</Text>
                  </View>
                </View>
              ))}
            </View>
          </View>

          <View style={styles.cylinderTableContainer}>
            <View style={styles.cylinderHeader}>
              <Text>CONTROL DE MOVIMIENTO DE CILINDROS</Text>
            </View>
            <View style={[styles.cylinderInfoLines, { marginTop: 10 }]}>
              <View style={styles.infoRow}>
                <Text style={styles.infoLineText}>Ingresa el cliente: _____________________</Text>
                <Text style={styles.infoLineText}>Salida del cliente: ____________________</Text>
                <Text style={styles.infoLineText}>Quedan cilindros en planta: ___________________</Text>
              </View>
            </View>
            <View style={styles.cylinderContainer}>
              <View style={styles.cylinderMainHeader}>
                <View style={styles.cylinderDetailColHeader}>
                  <Text style={styles.textBold}>Detalle de cilindros</Text>
                </View>
                <View style={styles.cylinderIngresoColHeader}>
                  <Text style={[styles.textBold, styles.textCenter]}>Ingresa el cliente</Text>
                </View>
                <View style={styles.cylinderSalidaColHeader}>
                  <Text style={[styles.textBold, styles.textCenter]}>Salida del cliente</Text>
                </View>
                <View style={styles.cylinderQuedanColHeader}>
                  <Text style={[styles.textBold, styles.textCenter]}>Quedan cilindros en Planta</Text>
                </View>
              </View>

              <View style={styles.cylinderSubColumns}>
                <View style={styles.emptySubCol}>
                  <Text></Text>
                </View>
                <View style={styles.subCol}>
                  <Text style={styles.subColText}>CONTEO DE{'\n'}SEGURIDAD</Text>
                </View>
                <View style={styles.subCol}>
                  <Text style={styles.subColText}>CONTEO DE JEFE{'\n'}DE PLANTA</Text>
                </View>
                <View style={styles.subCol}>
                  <Text style={styles.subColText}>CONTEO DE{'\n'}SEGURIDAD</Text>
                </View>
                <View style={styles.subCol}>
                  <Text style={styles.subColText}>CONTEO DE JEFE{'\n'}DE PLANTA</Text>
                </View>
                <View style={styles.quedanSubColEmpty}>
                  <Text></Text>
                </View>
              </View>

              {['CILINDRO 10K', 'CILINDRO 15K', 'CILINDRO 45K', 'CILINDRO 5K'].map((cylinder, index) => (
                <View key={index} style={styles.cylinderDataRow}>
                  <View style={styles.detailCell}>
                    <Text style={styles.cylinderText}>{cylinder}</Text>
                  </View>
                  <View style={styles.dataCell}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.dataCell}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.dataCell}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.dataCell}>
                    <Text>{''}</Text>
                  </View>
                  <View style={styles.quedanCell}>
                    <Text>{''}</Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    )
  }

  if (view === 'invoice') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={styles.header} fixed>
            <View style={[styles.headers, styles.invCodigo]}>
              <Text style={styles.text}>CÓDIGO</Text>
            </View>
            <View style={[styles.headers, styles.invDescripcion]}>
              <Text style={styles.text}>DESCRIPCIÓN</Text>
            </View>
            <View style={[styles.headers, styles.invUm]}>
              <Text style={styles.text}>U.M.</Text>
            </View>
            <View style={[styles.headers, styles.invCantidad]}>
              <Text style={styles.text}>CANTIDAD</Text>
            </View>
            <View style={[styles.headers, styles.invPrecioUnitario]}>
              <Text style={styles.text}>PRECIO{'\n'}UNITARIO</Text>
            </View>
            <View style={[styles.headers, styles.invDescuento]}>
              <Text style={styles.text}>DESCUENTO</Text>
            </View>
            <View style={[styles.headers, styles.invImpuesto]}>
              <Text style={styles.text}>IMPUESTO</Text>
            </View>
            <View style={[styles.headers, styles.invPrecioTotal]}>
              <Text style={styles.text}>PRECIO{'\n'}TOTAL</Text>
            </View>
          </View>

          {items.map((item, index) => {
            const precioTotal = Number.parseFloat(item.Price) * Number.parseFloat(item.Quantity);
            return (
              <View style={styles.tableRow} key={index}>
                <View style={[styles.cell, styles.invCodigo]}>
                  <Text>{item.ItemCode}</Text>
                </View>
                <View style={[styles.cell, styles.invDescripcion]}>
                  <Text>{item.Dscription}</Text>
                </View>
                <View style={[styles.cell, styles.invUm]}>
                  <Text>{item.SalUnitMsr}</Text>
                </View>
                <View style={[styles.cell, styles.invCantidad]}>
                  <Text>{Number.parseFloat(item.Quantity).toFixed(2)}</Text>
                </View>
                <View style={[styles.cell, styles.invPrecioUnitario]}>
                  <Text>{Number.parseFloat(item.Price).toFixed(2)}</Text>
                </View>
                <View style={[styles.cell, styles.invDescuento]}>
                  <Text>{Number.parseFloat(item.Descuento).toFixed(2)}</Text>
                </View>
                <View style={[styles.cell, styles.invImpuesto]}>
                  <Text>{Number.parseFloat(item.Impuesto).toFixed(2)}</Text>
                </View>
                <View style={[styles.cell, styles.invPrecioTotal]}>
                  <Text>{precioTotal.toFixed(2)}</Text>
                </View>
              </View>
            );
          })}

          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invCodigo]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invDescripcion]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invUm]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invCantidad]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invPrecioUnitario]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invDescuento]}>
            </View>
            {/* <View style={[styles.cell,styles.invPrecioTotal]}>
          </View> */}
            <View style={[styles.cell, styles.total]}>
            </View>
          </View>

          {header.DatosConvenio && header.DatosConvenio.length > 0 && (
            <View style={styles.conveniosTableContainer}>
              <View style={styles.conveniosTableHeader}>
                <View style={[styles.conveniosCell, styles.convenioCantidadCol]}>
                  <Text style={styles.conveniosHeaderText}>CANTIDAD</Text>
                </View>
                <View style={[styles.conveniosCell, styles.convenioUnidadCol]}>
                  <Text style={styles.conveniosHeaderText}>UNIDAD</Text>
                </View>
                <View style={[styles.conveniosCell, styles.convenioModeloCol]}>
                  <Text style={styles.conveniosHeaderText}>MODELO</Text>
                </View>
                <View style={[styles.conveniosCell, styles.convenioDescripcionCol]}>
                  <Text style={styles.conveniosHeaderText}>DESCRIPCIÓN</Text>
                </View>
              </View>

              {header.DatosConvenio.map((convenio, idx) => (
                <View key={idx} style={styles.conveniosTableRow}>
                  <View style={[styles.conveniosCell, styles.convenioCantidadCol]}>
                    <Text style={styles.convenioCellText}>
                      {Number.parseFloat(convenio.Quantity).toFixed(2)}
                    </Text>
                  </View>
                  <View style={[styles.conveniosCell, styles.convenioUnidadCol]}>
                    <Text style={styles.convenioCellText}>
                      {convenio.U_FMB_IS_CILINDRO === '1' ? 1 : 0}
                    </Text>
                  </View>
                  <View style={[styles.conveniosCell, styles.convenioModeloCol]}>
                    <Text style={styles.convenioCellText}>
                      {convenio.ItemCode}
                    </Text>
                  </View>
                  <View style={[styles.conveniosCell, styles.convenioDescripcionCol]}>
                    <Text style={styles.convenioCellText}>
                      {convenio.Dscription}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          )}

          <TableFooter header={header} items={items} view={view} />
        </View>
      </>)
  }

  if (view === 'debitNote') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={[styles.header1, { borderWidth: 1, borderColor: '#000' }]} fixed>
            <View style={[styles.headers, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Código</Text>
            </View>
            <View style={[styles.headers, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Descripción</Text>
            </View>
            <View style={[styles.headers, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>UM</Text>
            </View>
            <View style={[styles.headers, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Cantidad</Text>
            </View>
            <View style={[styles.headers, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Precio Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Valor Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.valorTotal]}>
              <Text style={styles.text}>Valor Total</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderColor: '#000' }]} key={index}>
              <View style={[styles.cell, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.ValorVentaUnitario || item.PriceAfVAT || 0).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.valorTotal]}>
                <Text>{Number(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.ean]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.qty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.unit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.description]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.price]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.igv]}>
            </View>
            {/* <View style={[styles.cell,styles.isc]}>
        </View> */}
            <View style={[styles.cell, styles.total]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    )
  }

  if (view === 'creditNote') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={[styles.header1, { borderWidth: 1, borderColor: '#000' }]} fixed>
            <View style={[styles.headers, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Código</Text>
            </View>
            <View style={[styles.headers, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Descripción</Text>
            </View>
            <View style={[styles.headers, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>UM</Text>
            </View>
            <View style={[styles.headers, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Cantidad</Text>
            </View>
            <View style={[styles.headers, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Precio Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Valor Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.valorTotal]}>
              <Text style={styles.text}>Valor Total</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderColor: '#000' }]} key={index}>
              <View style={[styles.cell, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.ValorVentaUnitario || item.PriceAfVAT || 0).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.valorTotal]}>
                <Text>{Number(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.ean]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.qty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.unit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.description]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.price]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.igv]}>
            </View>
            {/* <View style={[styles.cell,styles.isc]}>
        </View> */}
            <View style={[styles.cell, styles.total]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    )
  }

  if (view === 'invoice' && header.U_BPP_MDTD === '03') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={[styles.header1, { borderWidth: 1, borderColor: '#000' }]} fixed>
            <View style={[styles.headers, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Código</Text>
            </View>
            <View style={[styles.headers, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Descripción</Text>
            </View>
            <View style={[styles.headers, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>UM</Text>
            </View>
            <View style={[styles.headers, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Cantidad</Text>
            </View>
            <View style={[styles.headers, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Precio Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Valor Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.valorTotal]}>
              <Text style={styles.text}>Valor Total</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderColor: '#000' }]} key={index}>
              <View style={[styles.cell, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.ValorVentaUnitario || item.PriceAfVAT || 0).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.valorTotal]}>
                <Text>{Number(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.ean]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.qty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.unit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.description]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.price]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.igv]}>
            </View>
            {/* <View style={[styles.cell,styles.isc]}>
      </View> */}
            <View style={[styles.cell, styles.total]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    )
  }

  if (view === 'invoice') {
    return (
      <>
        <View style={styles.tableContainer}>
          <View style={[styles.header1, { borderWidth: 1, borderColor: '#000' }]} fixed>
            <View style={[styles.headers, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Código</Text>
            </View>
            <View style={[styles.headers, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Descripción</Text>
            </View>
            <View style={[styles.headers, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>UM</Text>
            </View>
            <View style={[styles.headers, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>Cantidad</Text>
            </View>
            <View style={[styles.headers, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Precio Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
              <Text style={styles.text}>
                Valor Venta{'\n'}Unitario
              </Text>
            </View>
            <View style={[styles.headers, styles.valorTotal]}>
              <Text style={styles.text}>Valor Total</Text>
            </View>
          </View>
          {items.map((item, index) => (
            <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderColor: '#000' }]} key={index}>
              <View style={[styles.cell, styles.codigo, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.ItemCode}</Text>
              </View>
              <View style={[styles.cell, styles.descripcion, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.Dscription}</Text>
              </View>
              <View style={[styles.cell, styles.um, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{item.UserBaseUn}</Text>
              </View>
              <View style={[styles.cell, styles.cantidad, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Quantity).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.pvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.Price).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.vvu, { borderRightWidth: 1, borderColor: '#000' }]}>
                <Text>{Number(item.ValorVentaUnitario || item.PriceAfVAT || 0).toFixed(2)}</Text>
              </View>
              <View style={[styles.cell, styles.valorTotal]}>
                <Text>{Number(item.LineTotal).toFixed(2)}</Text>
              </View>
            </View>
          ))}
          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.ean]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.qty]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.unit]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.description]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.price]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.igv]}>
            </View>
            {/* <View style={[styles.cell,styles.isc]}>
            </View> */}
            <View style={[styles.cell, styles.total]}>
            </View>
          </View>
          <TableFooter header={header} items={items} view={view} />
        </View>
      </>
    )
  }

  
  if (view === 'PurchaseOrder' && format === 2) {
    const currency = header?.DocCur;
    const localCurrency = header?.localCurrency;
    return (
      <>
        <View style={styles.tableContainer1}>
          <View style={[styles.headerOC, { borderTop: '1px', borderBottom: '1px' }]} fixed>
            <View style={[styles.headers, styles.idNum]}>
              <Text style={styles.text}>N</Text>
            </View>
            <View style={[styles.headers, styles.invCodigoOC1]}>
              <Text style={styles.text}>Código</Text>
            </View>
            <View style={[styles.headers, styles.invDescripcionOC1]}>
              <Text style={styles.text}>Descripción</Text>
            </View>
            <View style={[styles.headers, styles.invCantidad1]}>
              <Text style={styles.text}>Cantidad</Text>
            </View>
            <View style={[styles.headers, styles.umOC1]}>
              <Text style={styles.text}>U.M. </Text>
            </View>
            <View style={[styles.headers, styles.invPrecioUnitarioOC1]}>
              <Text style={styles.text}>P.Unitario</Text>
            </View>
            <View style={[styles.headers, styles.invPrecioTotalOC1]}>
              <Text style={styles.text}>Monto</Text>
            </View>
          </View>

          {items.map((item, index) => {
            const lineTotal = currency === localCurrency ? Number.parseFloat(item.LineTotal || 0) : Number.parseFloat(item.TotalFrgn || 0);
            const unitOfMeasure = item.BuyUnitMsr || '';
            return (
              <View style={[styles.tableRow, { borderBottom: '1px' }]} key={index}>
                <View style={[styles.cell, styles.idNum]}>
                  <Text>{index + 1}</Text>
                </View>
                <View style={[styles.cell, styles.invCodigoOC1]}>
                  <Text>{item.ItemCode || ''}</Text>
                </View>
                <View style={[styles.cell, styles.invDescripcionOC1, { textAlign: 'left' }]}>
                  <Text>{item.Dscription}</Text>
                </View>
                <View style={[styles.cell, styles.invCantidad1]}>
                  <Text>{FORMAT_NUMBER.new(item.Quantity)}</Text>
                </View>
                <View style={[styles.cell, styles.umOC1]}>
                  <Text>{unitOfMeasure}</Text>
                </View>
                <View style={[styles.cell, styles.invPrecioUnitarioOC1]}>
                  <Text>{`${item.Currency ? `${item.Currency} ` : ''}${FORMAT_NUMBER.new(item.Price)}`}</Text>
                </View>
                <View style={[styles.cell, styles.invPrecioTotalOC1]}>
                  <Text>{`${header?.DocCur ? `${header.DocCur} ` : ''}${FORMAT_NUMBER.new(lineTotal)}`}</Text>
                </View>
              </View>
            );
          })}

          <View style={[styles.tableRow]}>
            <View style={[styles.cell, styles.idNum]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invCodigoOC1]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invDescripcionOC1]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invCantidad1]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.umOC1]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invPrecioUnitarioOC1]}>
              <Text>{''}</Text>
            </View>
            <View style={[styles.cell, styles.invPrecioTotalOC1]}>
              <Text>{''}</Text>
            </View>
          </View>

          <TableFooter header={header} items={items} view={view} format={format} />
        </View>
      </>
    );
  }

  const isPurchaseDoc = isPurchaseDocument(view, header?.ObjType);
  const isSalesDoc = isSalesDocument(view, header?.ObjType);
  const currency = header?.DocCur;
  const localCurrency = header?.localCurrency;

  return (
    <View style={styles.tableContainer}>
      <View style={styles.header} fixed>
        <View style={[styles.headers, styles.itemcode]}>
          <Text style={styles.text}>CÓDIGO ARTÍCULO</Text>
        </View>
        <View style={[styles.headers, styles.ean]}>
          <Text style={styles.text}>CÓDIGO DE BARRAS</Text>
        </View>
        <View style={[styles.headers, styles.qty]}>
          <Text style={styles.text}>CANTIDAD</Text>
        </View>
        <View style={[styles.headers, styles.unit]}>
          <Text style={styles.text}>UNIDAD</Text>
        </View>
        <View style={[styles.headers, styles.description]}>
          <Text style={styles.text}>DESCRIPCIÓN</Text>
        </View>
        <View style={[styles.headers, styles.price]}>
          <Text style={styles.text}>PRECIO</Text>
        </View>
        <View style={[styles.headers, styles.dicount]}>
          <Text style={styles.text}>DSCTO</Text>
        </View>
        <View style={[styles.headers, styles.igv]}>
          <Text style={styles.text}>IGV</Text>
        </View>
        {/* <View style={[styles.headers,styles.isc]}>
              <Text style={styles.text}>ISC</Text>
          </View> */}
        <View style={[styles.headers, styles.total]}>
          <Text style={styles.text}>TOTAL</Text>
        </View>
      </View>
      {items.map((item, index) => {
        const lineTotal = ((isPurchaseDoc || isSalesDoc) && currency && localCurrency) ? currency === localCurrency ? Number.parseFloat(item.LineTotal || 0) : Number.parseFloat(item.TotalFrgn || 0) : Number.parseFloat(item.LineTotal || 0);
        return (
          <View style={styles.tableRow} key={index}>
            <View style={[styles.cell, styles.itemcode]}>
              <Text>{item.ItemCode}</Text>
            </View>
            <View style={[styles.cell, styles.ean]}>
              <Text>{`${item.CodeBars || ''}`}</Text>
            </View>
            <View style={[styles.cell, styles.qty]}>
              <Text>{FORMAT_NUMBER.new(item.Quantity)}</Text>
            </View>
            <View style={[styles.cell, styles.unit]}>
              <Text>{item.UserBaseUn}</Text>
            </View>
            <View style={[styles.cell, styles.description]}>
              <Text>{item.Dscription}</Text>
            </View>
            <View style={[styles.cell, styles.price]}>
              <Text>{`${FORMAT_NUMBER.new(item.Price)}`}</Text>
            </View>
            <View style={[styles.cell, styles.dicount]}>
              <Text>{Number.parseFloat(item.Descuento).toFixed(2)}</Text>
            </View>
            <View style={[styles.cell, styles.igv]}>
              <Text>{`${Number.parseFloat(item.Impuesto).toFixed(2)}`}</Text>
            </View>
            {/* <View style={[styles.cell,styles.isc]}>
                <Text>0</Text>
            </View> */}
            <View style={[styles.cell, styles.total]}>
              <Text>{`${FORMAT_NUMBER.new(lineTotal)}`}</Text>
            </View>
          </View>
        );
      })}
      <View style={[styles.tableRow]}>
        <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.ean]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.qty]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.unit]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.description]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.price]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.dicount]}>
          <Text>{''}</Text>
        </View>
        <View style={[styles.cell, styles.igv]}>
        </View>
        {/* <View style={[styles.cell,styles.isc]}>
          </View> */}
        <View style={[styles.cell, styles.total]}>
        </View>
      </View>
      <TableFooter header={header} items={items} />
    </View>

  );
};

export default ItemsTable